export const BaronPoly = (color) => {
  return `
       <svg xmlns="http://www.w3.org/2000/svg" width="400" height="180" viewBox="0 0 400 180" fill="none">
    <rect width="400" height="45.5512" fill="${color}"/>
    <g filter="url(#filter0_ii_31_291)">
    <rect x="9.48315" y="9.09315" width="118.539" height="27.929" fill="#181818"/>
    </g>
    <g filter="url(#filter1_ii_31_291)">
    <rect x="140.666" y="9.09315" width="118.539" height="27.929" fill="#181818"/>
    </g>
    <g filter="url(#filter2_ii_31_291)">
    <rect x="271.058" y="9.09315" width="118.539" height="27.929" fill="#181818"/>
    </g>
    <line y1="44.5512" x2="400" y2="44.5512" stroke="white" stroke-width="2"/>
    <rect width="400" height="45.5512" fill="${color}"/>
    <g filter="url(#filter3_ii_31_291)">
    <rect x="9.48315" y="9.09315" width="181.759" height="27.929" fill="#181818"/>
    </g>
    <g filter="url(#filter4_ii_31_291)">
    <rect x="207.838" y="9.09315" width="181.759" height="27.929" fill="#181818"/>
    </g>
    <line y1="44.5512" x2="400" y2="44.5512" stroke="white" stroke-width="2"/>
    <rect y="44.8163" width="400" height="45.5512" fill="${color}"/>
    <g filter="url(#filter5_ii_31_291)">
    <rect x="9.48315" y="53.9094" width="118.539" height="27.929" fill="#181818"/>
    </g>
    <g filter="url(#filter6_ii_31_291)">
    <rect x="140.666" y="53.9094" width="118.539" height="27.929" fill="#181818"/>
    </g>
    <g filter="url(#filter7_ii_31_291)">
    <rect x="271.058" y="53.9094" width="118.539" height="27.929" fill="#181818"/>
    </g>
    <line y1="89.3675" x2="400" y2="89.3675" stroke="white" stroke-width="2"/>
    <rect y="44.8163" width="400" height="45.5512" fill="${color}"/>
    <g filter="url(#filter8_ii_31_291)">
    <rect x="9.48315" y="53.9094" width="181.759" height="27.929" fill="#181818"/>
    </g>
    <g filter="url(#filter9_ii_31_291)">
    <rect x="207.838" y="53.9094" width="181.759" height="27.929" fill="#181818"/>
    </g>
    <line y1="89.3675" x2="400" y2="89.3675" stroke="white" stroke-width="2"/>
    <rect y="89.6325" width="400" height="45.5512" fill="${color}"/>
    <g filter="url(#filter10_ii_31_291)">
    <rect x="9.48315" y="98.7257" width="118.539" height="27.929" fill="#181818"/>
    </g>
    <g filter="url(#filter11_ii_31_291)">
    <rect x="140.666" y="98.7257" width="118.539" height="27.929" fill="#181818"/>
    </g>
    <g filter="url(#filter12_ii_31_291)">
    <rect x="271.058" y="98.7257" width="118.539" height="27.929" fill="#181818"/>
    </g>
    <line y1="134.184" x2="400" y2="134.184" stroke="white" stroke-width="2"/>
    <rect y="89.6325" width="400" height="45.5512" fill="${color}"/>
    <g filter="url(#filter13_ii_31_291)">
    <rect x="9.48315" y="98.7257" width="181.759" height="27.929" fill="#181818"/>
    </g>
    <g filter="url(#filter14_ii_31_291)">
    <rect x="207.838" y="98.7257" width="181.759" height="27.929" fill="#181818"/>
    </g>
    <line y1="134.184" x2="400" y2="134.184" stroke="white" stroke-width="2"/>
    <rect y="134.449" width="400" height="45.5512" fill="${color}"/>
    <g filter="url(#filter15_ii_31_291)">
    <rect x="9.48315" y="143.542" width="118.539" height="27.929" fill="#181818"/>
    </g>
    <g filter="url(#filter16_ii_31_291)">
    <rect x="140.666" y="143.542" width="118.539" height="27.929" fill="#181818"/>
    </g>
    <g filter="url(#filter17_ii_31_291)">
    <rect x="271.058" y="143.542" width="118.539" height="27.929" fill="#181818"/>
    </g>
    <line y1="179" x2="400" y2="179" stroke="white" stroke-width="2"/>
    <rect y="134.449" width="400" height="45.5512" fill="${color}"/>
    <g filter="url(#filter18_ii_31_291)">
    <rect x="9.48315" y="143.542" width="181.759" height="27.929" fill="#181818"/>
    </g>
    <g filter="url(#filter19_ii_31_291)">
    <rect x="207.838" y="143.542" width="181.759" height="27.929" fill="#181818"/>
    </g>
    <line y1="179" x2="400" y2="179" stroke="white" stroke-width="2"/>
    <defs>
    <filter id="filter0_ii_31_291" x="7.48315" y="7.09315" width="122.539" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_31_291"/>
    <feOffset dx="-4" dy="4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_31_291"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_31_291"/>
    <feOffset dx="4" dy="-4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
    <feBlend mode="normal" in2="effect1_innerShadow_31_291" result="effect2_innerShadow_31_291"/>
    </filter>
    <filter id="filter1_ii_31_291" x="138.666" y="7.09315" width="122.539" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_31_291"/>
    <feOffset dx="-4" dy="4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_31_291"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_31_291"/>
    <feOffset dx="4" dy="-4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
    <feBlend mode="normal" in2="effect1_innerShadow_31_291" result="effect2_innerShadow_31_291"/>
    </filter>
    <filter id="filter2_ii_31_291" x="269.058" y="7.09315" width="122.539" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_31_291"/>
    <feOffset dx="-4" dy="4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_31_291"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_31_291"/>
    <feOffset dx="4" dy="-4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
    <feBlend mode="normal" in2="effect1_innerShadow_31_291" result="effect2_innerShadow_31_291"/>
    </filter>
    <filter id="filter3_ii_31_291" x="7.48315" y="7.09315" width="185.759" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_31_291"/>
    <feOffset dx="-4" dy="4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_31_291"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_31_291"/>
    <feOffset dx="4" dy="-4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
    <feBlend mode="normal" in2="effect1_innerShadow_31_291" result="effect2_innerShadow_31_291"/>
    </filter>
    <filter id="filter4_ii_31_291" x="205.838" y="7.09315" width="185.759" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_31_291"/>
    <feOffset dx="-4" dy="4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_31_291"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_31_291"/>
    <feOffset dx="4" dy="-4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
    <feBlend mode="normal" in2="effect1_innerShadow_31_291" result="effect2_innerShadow_31_291"/>
    </filter>
    <filter id="filter5_ii_31_291" x="7.48315" y="51.9094" width="122.539" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_31_291"/>
    <feOffset dx="-4" dy="4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_31_291"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_31_291"/>
    <feOffset dx="4" dy="-4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
    <feBlend mode="normal" in2="effect1_innerShadow_31_291" result="effect2_innerShadow_31_291"/>
    </filter>
    <filter id="filter6_ii_31_291" x="138.666" y="51.9094" width="122.539" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_31_291"/>
    <feOffset dx="-4" dy="4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_31_291"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_31_291"/>
    <feOffset dx="4" dy="-4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
    <feBlend mode="normal" in2="effect1_innerShadow_31_291" result="effect2_innerShadow_31_291"/>
    </filter>
    <filter id="filter7_ii_31_291" x="269.058" y="51.9094" width="122.539" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_31_291"/>
    <feOffset dx="-4" dy="4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_31_291"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_31_291"/>
    <feOffset dx="4" dy="-4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
    <feBlend mode="normal" in2="effect1_innerShadow_31_291" result="effect2_innerShadow_31_291"/>
    </filter>
    <filter id="filter8_ii_31_291" x="7.48315" y="51.9094" width="185.759" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_31_291"/>
    <feOffset dx="-4" dy="4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_31_291"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_31_291"/>
    <feOffset dx="4" dy="-4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
    <feBlend mode="normal" in2="effect1_innerShadow_31_291" result="effect2_innerShadow_31_291"/>
    </filter>
    <filter id="filter9_ii_31_291" x="205.838" y="51.9094" width="185.759" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_31_291"/>
    <feOffset dx="-4" dy="4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_31_291"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_31_291"/>
    <feOffset dx="4" dy="-4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
    <feBlend mode="normal" in2="effect1_innerShadow_31_291" result="effect2_innerShadow_31_291"/>
    </filter>
    <filter id="filter10_ii_31_291" x="7.48315" y="96.7257" width="122.539" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_31_291"/>
    <feOffset dx="-4" dy="4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_31_291"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_31_291"/>
    <feOffset dx="4" dy="-4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
    <feBlend mode="normal" in2="effect1_innerShadow_31_291" result="effect2_innerShadow_31_291"/>
    </filter>
    <filter id="filter11_ii_31_291" x="138.666" y="96.7257" width="122.539" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_31_291"/>
    <feOffset dx="-4" dy="4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_31_291"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_31_291"/>
    <feOffset dx="4" dy="-4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
    <feBlend mode="normal" in2="effect1_innerShadow_31_291" result="effect2_innerShadow_31_291"/>
    </filter>
    <filter id="filter12_ii_31_291" x="269.058" y="96.7257" width="122.539" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_31_291"/>
    <feOffset dx="-4" dy="4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_31_291"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_31_291"/>
    <feOffset dx="4" dy="-4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
    <feBlend mode="normal" in2="effect1_innerShadow_31_291" result="effect2_innerShadow_31_291"/>
    </filter>
    <filter id="filter13_ii_31_291" x="7.48315" y="96.7257" width="185.759" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_31_291"/>
    <feOffset dx="-4" dy="4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_31_291"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_31_291"/>
    <feOffset dx="4" dy="-4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
    <feBlend mode="normal" in2="effect1_innerShadow_31_291" result="effect2_innerShadow_31_291"/>
    </filter>
    <filter id="filter14_ii_31_291" x="205.838" y="96.7257" width="185.759" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_31_291"/>
    <feOffset dx="-4" dy="4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_31_291"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_31_291"/>
    <feOffset dx="4" dy="-4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
    <feBlend mode="normal" in2="effect1_innerShadow_31_291" result="effect2_innerShadow_31_291"/>
    </filter>
    <filter id="filter15_ii_31_291" x="7.48315" y="141.542" width="122.539" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_31_291"/>
    <feOffset dx="-4" dy="4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_31_291"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_31_291"/>
    <feOffset dx="4" dy="-4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
    <feBlend mode="normal" in2="effect1_innerShadow_31_291" result="effect2_innerShadow_31_291"/>
    </filter>
    <filter id="filter16_ii_31_291" x="138.666" y="141.542" width="122.539" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_31_291"/>
    <feOffset dx="-4" dy="4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_31_291"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_31_291"/>
    <feOffset dx="4" dy="-4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
    <feBlend mode="normal" in2="effect1_innerShadow_31_291" result="effect2_innerShadow_31_291"/>
    </filter>
    <filter id="filter17_ii_31_291" x="269.058" y="141.542" width="122.539" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_31_291"/>
    <feOffset dx="-4" dy="4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_31_291"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_31_291"/>
    <feOffset dx="4" dy="-4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
    <feBlend mode="normal" in2="effect1_innerShadow_31_291" result="effect2_innerShadow_31_291"/>
    </filter>
    <filter id="filter18_ii_31_291" x="7.48315" y="141.542" width="185.759" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_31_291"/>
    <feOffset dx="-4" dy="4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_31_291"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_31_291"/>
      <feOffset dx="4" dy="-4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
    <feBlend mode="normal" in2="effect1_innerShadow_31_291" result="effect2_innerShadow_31_291"/>
    </filter>
    <filter id="filter19_ii_31_291" x="205.838" y="141.542" width="185.759" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_31_291"/>
    <feOffset dx="-4" dy="4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_31_291"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_31_291"/>
    <feOffset dx="4" dy="-4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
    <feBlend mode="normal" in2="effect1_innerShadow_31_291" result="effect2_innerShadow_31_291"/>
    </filter>
    </defs>
    </svg>
        `;
};
